import React from 'react';
import { Button, Container } from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';
import './style.scss';
import { SEARCH_PATH } from '../../config/constants';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <Container className="NotFound">
      <div className="row NotFound__row">
        <div className="col-lg-8 offset-lg-2 col-md-8 offset-md-2  NotFound__text" id="main">
          <h1>{t('general.not_found')}</h1>
          <h2>{t('general.not_found_subtitle')}</h2>

          <h3>{t('general.not_found_description')}</h3>
          <div className="NotFound__buttons">
            <Button href="/">{t('general.to_home')}</Button>

            <Button className="NotFound__buttons__noborder" href={SEARCH_PATH}>
              {t('general.to_search')}
              <i className="icon icon-search" />
            </Button>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default NotFound;
